<template>
  <div id="tree-side">
    <div class="natural-connections">
      <div class="title">CONEXÕES NATURAIS:</div>
      <div class="tags">
        <div class="tag" v-for="con in naturalConnections">
          <div :data-tree-side-group="con.group">
            {{con.cargo}}
          </div>
        </div>
        <div v-if="naturalConnections.length === 0">
          Nenhuma
        </div>
        <div style="clear: both" />
      </div>
    </div>
    <hr />
    <div class="possible-connections">
      <div class="title">CONEXÕES POSSÍVEIS:</div>
      <div class="tags">
        <div class="possible-name" v-for="con in possibleConnections">
          <div class="possible-title" :data-tree-side-group="con.group">{{con.cargo}}</div>
          <div v-if="currentFront === con.front" class="possible-word">{{con.area}}</div>
          <div v-else class="possible-tag" @click="changeFront(con)">{{con.front}}</div>
        </div>
        <div v-if="possibleConnections.length === 0">
          Nenhuma
        </div>
        <div style="clear: both" />
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';

  export default {
    props: {
    },
    data() {
      return {
        currentFront: window.$fronts ? window.$fronts[0].name : '',
        naturalConnections: [],
        possibleConnections: [],
        lock: false,
      };
    },
    created() {
      EventSystem.$on('tree-view-open', node => this.updateInfo(node));
      EventSystem.$on('tree-view-node-click', node => this.updateInfo(node));

      EventSystem.$on('front-changed', front => {
        this.currentFront = front.name;
      });

      EventSystem.$on('fronts-loaded', front => {
        this.currentFront = window.$fronts[0].name;
      });

      EventSystem.$on('nodes-shown', () => {
        this.lock = false;
      });
    },
    computed: {
    },
    methods: {
      changeFront(node) {
        const front = window.$fronts.find(f => f.name === node.front);
        if (!front) {
          console.error('Change front via tag failed', front, this.currentFront, window.$fronts);
        } else {
          EventSystem.$emit('tree-view-close', front);

          setTimeout(() => {
            EventSystem.$emit('view-change', 1);
            setTimeout(() => {
              this.lock = true;
              const timerId = setInterval(() => {
                if (!this.lock) {
                  clearInterval(timerId);
                  EventSystem.$emit('selected-node', node);
                }
              }, 100);
              EventSystem.$emit('front-changed', front);
            }, 300);
          }, 300);
        }
      },
      updateInfo(node) {
        const allLinks = window.$links
          .filter(l => l.target === node.id)
          .map(l => ({ ...(typeof l.source === 'object' ? l.source : window.$nodes.find(n => n.id === l.source)), type: l.value }));

        this.naturalConnections = allLinks.filter(n => n.type === 0);
        this.possibleConnections = allLinks.filter(n => n.type === 1);
      }
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/tree-side.vue